import { render, staticRenderFns } from "./UserInvitationsTab.vue?vue&type=template&id=a0d09cac&scoped=true"
import script from "./UserInvitationsTab.vue?vue&type=script&lang=js"
export * from "./UserInvitationsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0d09cac",
  null
  
)

export default component.exports